import dayjs from "dayjs";

export function getMonthDays(month: number = dayjs().month()): Date[][] {
  const year: number = dayjs().year();
  const firstDayOfTheMonth: dayjs.Dayjs = dayjs(new Date(year, month, 1));
  const firstDayOfMonthIndex: number = firstDayOfTheMonth.day();
  let currentMonthCount: number = 1 - firstDayOfMonthIndex;

  const daysMatrix: Date[][] = new Array(6).fill([]).map(() => {
    return new Array(7).fill(null).map(() => {
      const currentDate: Date = dayjs(new Date(year, month, currentMonthCount)).toDate();
      currentMonthCount++;
      return currentDate;
    });
  });

  return daysMatrix;
}

export function getNowMonth(): number {
  const month: number = dayjs().month();
  return month;
}

export function getMonth(month: number = dayjs().month()): Date {
  const year: number = dayjs().year();
  const firstDayOfTheMonth: Date = dayjs(new Date(year, month, 1)).toDate();
  return firstDayOfTheMonth;
}

export function convertStr(date: Date, format: string): string {
  const dateString = dayjs(date).format(format);
  return dateString;
}

export function getNextDate(recordAt: string, daysLater: number, format?: string): string {
  const date: Date = new Date(recordAt);
  date.setDate(date.getDate() + daysLater);
  return convertStr(date, format ?? "YYYY-MM-DD");
}

/**
 * 少数を指定位置で四捨五入 (画面上に少数を表示する場合はこの関数の戻り値を使用すること)
 * @param {number} num 対象の数値
 * @param {number} [roundDigit=1] 丸め桁位置 デフォルトで少数第一位を四捨五入
 */
export function roundNumber(num: number, roundDigit: number = 1) {
  const accuracy = Math.pow(10, Math.round(roundDigit) - 1);
  return Number((Math.round(num * accuracy) / accuracy).toFixed(roundDigit - 1));
}

/**
 * 少数を指定位置で切り上げ (画面上に少数を表示する場合はこの関数の戻り値を使用すること)
 * @param {number} num 対象の数値
 * @param {number} [ceilDigit=1] 丸め桁位置 デフォルトで少数第一位を切り上げ
 */
export function ceilNumber(num: number, ceilDigit: number = 1) {
  const accuracy = Math.pow(10, Math.round(ceilDigit) - 1);
  return Number((Math.ceil(num * accuracy) / accuracy).toFixed(ceilDigit - 1));
}

/** ゼロ埋めされていない文字列をISO文字列に変換 */
export function toISODateStr(dateOrStr?: string | Date) {
  if (!dateOrStr) {
    return "";
  }

  const date = dateOrStr instanceof Date ? dateOrStr : new Date(dateOrStr);
  const dateStr = date.toLocaleDateString("swe");
  return dateStr === "Invalid Date" ? "" : dateStr;
}

/** 数値のプロパティはnumber型に変換 */
export function toNumberProps(value: any): any {
  if (typeof value === "object") {
    Object.keys(value || {}).forEach(key => {
      const v = (value as any)[key];
      (value as any)[key] = toNumberProps(v);
    });

    return value;
  } else {
    const toNum = (v: any) =>
      Array.isArray(v)
        ? v.map((vv: any) => toNumberProps(vv))
        : !/[0-9]/.test(v) || isNaN(Number(v))
          ? v
          : Number(v);
    return Array.isArray(value) ? value.map((v: any) => toNum(v)) : toNum(value);
  }
}

export function toQueryString(params: any) {
  return Object.entries(params)
    .map(([key, value]) => (value ? `${key}=${value}` : key))
    .join("&");
}

export function resizeImage(imageFile: File, maxWidth: number = 600, maxHeight: number = 600) {
  return new Promise<string>(resolve => {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();
      img.src = reader.result as string;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx?.drawImage(img, 0, 0, width, height);
        const mimeType = imageFile.type;
        const type = mimeType === "image/png" ? "image/png" : "image/jpeg";

        canvas.toBlob(blob => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            resolve(url);
          }
        }, type);
      };
    };
    reader.readAsDataURL(imageFile);
  });
}
